module.exports = "/_next/static/images/maine-bf8baffae87c4e1289d5e6daed651f95.svg";